import React from 'react';

import get from 'lodash/get';
import set from 'lodash/set';
import {TextInput} from 'PMT/components/form';
import Select from 'react-select';
import Config from 'constants/Config';

const FormGroup = ({label, style, children}) => (
    <div className="row form-group" style={style}>
      <div className="col-xs-4 control-label">
        <label>{label}</label>
      </div>

      <div className="col-xs-6">{children}</div>
    </div>
);

const SaferpayConfigurationView = ({
  pspSettings,
  onChange,
}) => {
  const options = [
    {
      value: '',
      label: 'DEFAULT (' + (Config.IS_PROD ? 'PROD' : 'TEST') + ')'
    },
    {value: 'https://www.saferpay.com/api', label: 'PROD'},
    {value: 'https://test.saferpay.com/api', label: 'TEST'}];
  const stringValue = get(pspSettings, 'saferpay.saferpayApiUrl', null) || '';
  const selectedValue = options.find(opt => opt.value === stringValue)
      || options[0];
  return (
    <div className="top-buffer-50">
      <h3 className="text-center" style={{ marginBottom: 50 }}>
        Saferpay configuration
      </h3>

      {/* customer id */}
      <FormGroup label="Customer ID" style={{ marginTop: 50 }}>
        <TextInput
          value={get(pspSettings, 'saferpay.customerID', null)}
          onChange={value => {
            onChange(set(pspSettings, 'saferpay.customerID', value));
          }}
        />
      </FormGroup>

       {/* customer id */}
       <FormGroup label="Terminal ID">
        <TextInput
          value={get(pspSettings, 'saferpay.terminalID', null)}
          onChange={value => {
            onChange(set(pspSettings, 'saferpay.terminalID', value));
          }}
        />
      </FormGroup>

      {/* shop private key */}
      <FormGroup label="Auth token">
        <TextInput
            value={get(pspSettings, 'saferpay.authToken', null)}
            onChange={value => {
              onChange(set(pspSettings, 'saferpay.authToken', value));
            }}
        />
      </FormGroup>

      <FormGroup label="Api Url">
        <Select
            value={selectedValue}
            onChange={option => {
              onChange(
                  set(pspSettings, 'saferpay.saferpayApiUrl',
                      option.value === '' ? null : option.value));
            }}
            options={options}
            clearable={false}

        />
      </FormGroup>

    </div>
  );
};

export default SaferpayConfigurationView;
